// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"b50ffe6e","107":"5bc8e780","210":"0f7ac087","252":"76d17a76","527":"de2bd1d7","646":"a13bbeee"}[chunkId] + ".chunk.js";
};